<template>
    <div id="dishes">
        <div class="row">
            <div class="col-md-12 flex flex-wrap single-dish-padding-top">
                <h2 class="content_header_h2 flex-grow mb-4">
                    <span class="lnr lnr-text-align-left"></span> {{ dishes_title_trans }}
                </h2>
                <a v-if="dishes_count >= 10 && menu_download_link"
                   :href="menu_download_link" class="btn btn-primary max-h-36" target="_blank">
                    {{ download_menu_trans }}
                </a>
                <form v-else-if="dishes_count >= 10 && !menu_download_link" action="/dishesmenu/download-menu" method="POST">
                    <input type="hidden" name="_token" :value="csrfToken">
                    <input type="hidden" name="company_id" :value="restaurant_id">
                    <button type="submit" class="btn btn-secondary max-h-36">{{ download_menu_trans }}</button>
                </form>
            </div>
        </div>

        <div v-if="descriptions && descriptions.length > 0" class="background-orange restaurant-description mb-4">
            <div class="p20">
                <p v-for="description in descriptions">
                    <span v-html="description"></span>
                </p>
            </div>
        </div>

        <div class="background-white p20 full-menu">
            <div id="menu-container">
                <div class="show-mobile shadow">
                    <div v-for="(category, index) in dishes" :key="'category_'+index">
                        <h3 class="content_header_h3">
                            <span :id="slugify(category.title)"></span> {{ category.title }}
                        </h3>

                        <div v-for="(dish, index) in category.dishes">
                            <div class="restaurant-dishes-holder" :key="'dish_'+index">
                                <div class="restaurant-food-img">
                                    <a :href="`/dishes/${dish.title}/${restaurant_city}`" :title="dish.name">
                                        <img :src="`${dish.restaurant_image}`" :alt="`${dish.title}`">
                                    </a>
                                </div>

                                <div class="py-3 restaurant-food-name">
                                    <a :href="`/dishes/${dish.title}/${restaurant_city}`" :title="dish.name">
                                        {{ dish.name }}
                                    </a>
                                </div>

                                <div>
                                    {{ dish.details | str_limit(100) }}
                                </div>

                                <div class="items-center price">
                                    <span v-if="dish.converted_price && typeof dish.converted_price !== 'object'"
                                          style="color:#739745">
                                      {{ dish.converted_price }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="show-desktop">
                    <div v-for="(category, index) in dishes" :key="'category_'+index" class="mb-6">
                        <h3 class="my-6 content_header_h3 text-center lg:text-left">
                            <span :id="slugify(category.title)"></span> {{ category.title }}
                        </h3>
                        <div v-for="(dish, index) in category.dishes">
                            <div class="restaurant-dishes-holder md-flex-col" :key="'dish_'+index"
                                 style="display: flex; align-items: center;">
                                <div class="col-xs-12 col-sm-2 col-lg-1 restaurant-food-img">
                                    <a :href="`/dishes/${dish.title}/${restaurant_city}`"
                                       :title="dish.name"
                                       :style="`background-image: url('${dish.restaurant_image}'); width: 60px; height: 60px; background-size: cover; background-repeat: no-repeat; background-position: 50% 50%;`">
                                    </a>
                                </div>

                                <div class="col-xs-12 col-sm-8 ">
                                    <div class="col-md-10 flex justify-center py-3 lg:justify-start">
                                        <a :href="`/dishes/${dish.title}/${restaurant_city}`"
                                           :title="dish.name"
                                           style="font-size: 15px;">
                                            <b>{{ dish.name }}</b>
                                        </a>
                                    </div>
                                    <!--                                <div class="col-md-2 flex justify-center lg:justify-start">-->
                                    <!--                                    <star-rating v-if="dish.rating" active-color="#739745" :read-only="true"-->
                                    <!--                                                 :rating="dish.rating" :show-rating="false" :inline="true"-->
                                    <!--                                                 :star-size="15"></star-rating>-->
                                    <!--                                </div>-->

                                    <div class="col-md-12 flex justify-center lg:justify-start">
                                        {{ dish.details | str_limit(100) }}
                                    </div>
                                </div>

                                <div class="col-sm-2 col-xs-12 flex flex-col lg:items-end items-center">
                                    <!--                <a v-if="dish.comment_number > 0" :href="`/dishes/${dish.title}/${restaurant_city}`" :title="dish.name"-->
                                    <!--                   style="font-size: 1.2em;">-->
                                    <!--                  <i class="lnr lnr-bullhorn"></i> {{ dish.comment_number }}-->
                                    <!--                </a>-->

                                    <!--                <a v-else :href="`/dishes/${dish.title}/${restaurant_city}/#reviews`" :title="comment_action_trans"-->
                                    <!--                   style="font-size: 1.2em;" class="js_hover">-->
                                    <!--                  <i class="lnr lnr-bullhorn"></i> {{ comment_action_trans }}-->
                                    <!--                </a>-->

                                    <span v-if="dish.converted_price && typeof dish.converted_price !== 'object'"
                                          style="color:#739745">
                                      {{ dish.converted_price }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        restaurant_city: {
            type: String,
            required: true
        },
        restaurant_id: {
            type: Number,
            required: true
        },
        comments_trans: {
            type: String,
            required: true
        },
        comment_action_trans: {
            type: String,
            required: true
        },
        dishes_title_trans: {
            type: String,
            required: true
        },
        read_more_trans: {
            type: String,
            required: true
        },
        download_menu_trans: {
            type: String,
            required: true
        },
        php_dishes: {
            type: String,
            required: true
        },
        paragraphs: {
            type: String,
            required: true
        },
        menu_route: {
            type: String,
            required: true
        },
        dishes_count: {
            type: Number,
            required: true
        },
        menu_download_link: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            dishes: [],
            descriptions: [],
            isMobile: false,
            csrfToken: null
        };
    },
    methods: {
        slugify(string) {
            return string.toLowerCase().replace(/[^\w ]+/g, "").replace(/ +/g, "-");
        }
    },
    created() {
        let self = this;

        let apiDishes = JSON.parse(self.php_dishes);

        $.each(apiDishes, function (category, dishes) {
            self.dishes.push({dishes: dishes, title: category});
        });

        self.descriptions = JSON.parse(self.paragraphs);

        self.isMobile = new MobileDetect(window.navigator.userAgent).mobile();

        self.$nextTick(() => {
            window.readMore(
                $('#menu-container'),
                '<a href="' + self.menu_route + '" class="btn btn-primary">' + self.read_more_trans + '</a>',
                650
            );
        });

        self.csrfToken = $('meta[name="csrf-token"]').attr('content');
    }
};
</script>

<style>
@media (max-width: 991px) {
    .md-flex-col {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .show-mobile {
        display: block;
    }

    .show-desktop {
        display: none;
    }

    /* mobile styles below */
    .content_header_h3 {
        color: #6b7280;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 16px;
        padding: 16px;
        background-color: #f9fafb;
        border-bottom: none;
    }

    .restaurant-dishes-holder {
        padding: 16px 16px 8px 16px;
        border-top: 1px solid #e9e9e9;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
    }

    .restaurant-food-img {
        margin-right: 16px;
    }

    .restaurant-food-img img {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        object-fit: cover;
    }

    .restaurant-food-name {
        max-width: 50%;
    }

    .items-center.price {
        margin-left: auto;
    }

    .items-center.price > span {
        margin-left: 16px;
    }
}

@media (max-width: 571px) {
    .full-menu {
        padding: 5px;
    }
}

/* desktop styles below */
@media (min-width: 992px) {
    .restaurant-dishes-holder {
        margin-bottom: 10px;
        padding-bottom: 10px;
        background: linear-gradient(
            to left,
            rgb(255, 255, 255) 0%,
            rgb(115, 151, 69) 12%,
            rgb(73, 151, 17) 47%,
            rgb(255, 255, 255) 100%
        ) left bottom no-repeat;
        background-size: 100% 1px; /* if linear-gradient, we need to resize it */
    }

    .restaurant-food-img {
        display: flex;
        justify-content: center;
        padding: 0 !important;
    }

    .restaurant-food-img > a {
        border-radius: 50%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ListDishesOnRestaurant.vue